import { useEffect, useRef, useState } from "react";
import './Gas-consumption.css';
import * as echarts from "echarts";
import chartConfig from "./Gas-charts.json";

const CHART_CONFIG = {
  tooltipDecimals: 3,
  yAxisDecimals: 0,
  yAxisPadding: 0.1,
  barWidth: '30%',
  lineColor: "#8A0194",
};

const GasConsumption = ({ data }) => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState(chartConfig.sampleData || {});
  
  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      console.log("Setting new chartData in GasConsumption:", data);
      setChartData(data);
    }
  }, [data]);
  
  useEffect(() => {
    // Validate that we have the chart container and data
    if (!chartRef.current) {
      console.log("Gas chart ref not available");
      return;
    }
    
    if (!chartData || (typeof chartData === 'object' && Object.keys(chartData).length === 0)) {
      console.log("No gas data available for chart", chartData);
      return;
    }
    
    console.log("Initializing gas chart with data:", chartData);
    let chartInstance = echarts.init(chartRef.current);
    let resizeObserver;

    const option = {
      tooltip: {
        trigger: 'axis',
        appendToBody: true,
        confine: false,
        backgroundColor: 'white',
        borderColor: '#ccc',
        borderWidth: 1,
        extraCssText: 'z-index: 9999;',
        textStyle: { color: '#333', fontSize: 14 },
      },
      xAxis: {
        type: 'category',
        data: chartData.timestamp || [],
        name: 'Time',
        nameLocation: 'middle',
        nameGap: 25,
        axisLabel: { fontSize: 12, color: '#333', rotate: 0, interval: 'auto' },
        axisLine: { show: true, lineStyle: { color: '#333' } },
        axisTick: { show: true, alignWithLabel: true },
        splitLine: { show: false },
      },
      yAxis: {
        type: 'value',
        name: 'Consumption (Tsd.)',
        nameLocation: 'middle',
        nameGap: 70,
        nameTextStyle: { color: 'black', fontSize: 12 },
        axisLabel: { show: true, fontSize: 11, color: '#333' },
        axisLine: { show: true, lineStyle: { color: '#333' } },
        axisTick: { show: true },
        splitLine: { show: true, lineStyle: { type: 'dashed', color: '#ccc' } },
      },
      series: [
        {
          name: 'Gas Consumption',
          type: 'bar',
          barWidth: CHART_CONFIG.barWidth,
          itemStyle: { color: CHART_CONFIG.lineColor },
          data: chartData.Normvolumen_Gas_7_732_96_05_18_Durchflussmenge ? 
            chartData.Normvolumen_Gas_7_732_96_05_18_Durchflussmenge.map(item => 
              typeof item === 'object' ? (Number(item.value) || 0) : (Number(item) || 0)
            ) : [],
        },
      ],
      grid: {
        top: 30,
        left: chartRef.current?.offsetWidth < 500 ? 60 : '10%',
        right: chartRef.current?.offsetWidth < 500 ? 20 : '5%',
        bottom: '15%',
        containLabel: true
      },
    };

    console.log("Gas chart option:", option);
    chartInstance.setOption(option);

    // Add ResizeObserver for better responsiveness
    resizeObserver = new ResizeObserver(() => {
      if (chartInstance) {
        chartInstance.resize();
      }
    });

    resizeObserver.observe(chartRef.current);

    const handleResize = () => chartInstance.resize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      chartInstance.dispose();
    };
  }, [chartData]);

  return (
    <div className="active-power-container">
      <div
        ref={chartRef}
        className="chart_activepower"
      />
    </div>
  );
};

export default GasConsumption;